import { type ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { TButton } from '../buttons'
import { type PageRoute } from './Navigation'

type NavigationButtonProps = PageRoute & {
  isCollapsed: boolean
  currentPath: string
  onClick?: VoidFunction
}

export const NavigationButton = ({
  path,
  matchFormat,
  label,
  icon,
  isCollapsed,
  isExternalLink,
  rightSection,
  currentPath,
  onClick,
  search,
}: NavigationButtonProps): ReactNode => {
  const isActive = matchFormat === 'exact' ? currentPath === path : currentPath.startsWith(path)

  return (
    <TButton
      buttonType={isCollapsed ? 'icon-rounded' : 'default'}
      color={isActive ? 'brand' : 'neutral'}
      component={Link}
      icon={icon}
      iconProps={{ filled: isActive }}
      justify='left'
      rel={isExternalLink ? 'noopener noreferrer' : undefined}
      rightSection={rightSection}
      search={search}
      target={isExternalLink ? '_blank' : undefined}
      to={path}
      tooltip={isCollapsed ? label : undefined}
      variant={isActive ? 'primary' : 'ghost'}
      onClick={onClick}
    >
      {label}
    </TButton>
  )
}
